import axios from "axios";
import { getAccessToken, getCompanyId, getUserId } from "./utils.js";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import store from "../store.js";
import { formatXResponseData } from "./socialResponseActionUtils.js";

export const INBOX_LIST_LOADING = "INBOX_LIST_LOADING";
export const SET_ASSIGN_MODAL = "SET_ASSIGN_MODAL";

export const SET_AGENT_LIST = "SET_AGENT_LIST";
export const ASSIGN_AGENT = "ASSIGN_AGENT";

export const COMMENT_REPLY = "COMMENT_REPLY";
export const SET_PRIORITY_OPTION = "SET_PRIORITY_OPTION";
export const SET_MESSAGE_TYPE_OPTION = "SET_MESSAGE_TYPE_OPTION";
export const SET_STATUS_OPTION = "SET_STATUS_OPTION";
export const SET_AGENT_OPTION = "SET_AGENT_OPTION";
export const SET_OFFSET_VALUE = "SET_OFFSET_VALUE";
export const ROLE_UPDATE = "ROLE_UPDATE";
export const TOGGLE_FILTER_COLUMN = "TOGGLE_FILTER_COLUMN";
export const SET_FILTERS = "SET_FILTERS";
export const FETCH_TWITTER_ACCOUNT_LIST = "FETCH_TWITTER_ACCOUNT_LIST";
export const TWITTER_OAUTH_TOKEN = "TWITTER_OAUTH_TOKEN";
export const TWITTER_AUTHENTICATE = "TWITTER_AUTHENTICATE";
export const SET_SELECTED_AGENT_OPTIONS = "SET_SELECTED_AGENT_OPTIONS";
export const SET_SORT_OPTION = "SET_SORT_OPTION";
export const FETCH_CXM_PAGES_LIST = "FETCH_CXM_PAGES_LIST";
export const MSG_STATUS_CHANGE = "MSG_STATUS_CHANGE";
export const TOGGLE_AUTO_ASSIGN = "TOGGLE_AUTO_ASSIGN";
export const FETCH_AUTO_ASSIGN = "FETCH_AUTO_ASSIGN";
export const SET_SELECTED_PAGES = "SET_SELECTED_PAGES";
export const SET_CURRENT_POST = "SET_CURRENT_POST";
export const FETCH_COMMENTS_THREAD = "FETCH_COMMENTS_THREAD";
export const TOGGLE_AUTO_RESPONSE = "TOGGLE_AUTO_RESPONSE";
export const FETCH_AUTO_RESPONSE = "FETCH_AUTO_RESPONSE";
export const FETCH_AUTO_RESPONSE_LIST = "FETCH_AUTO_RESPONSE_LIST";
export const RESPONSE_MODE = "RESPONSE_MODE";
export const UPDATE_USER_STATUS_INBOX = "UPDATE_USER_STATUS_INBOX";
export const FETCH_MSG_COUNT = "FETCH_MSG_COUNT";
export const PAGE_TOKEN_LIST = "PAGE_TOKEN_LIST";
export const SET_AGENT_ACCESSABLE_PAGES = "SET_AGENT_ACCESSABLE_PAGES";
export const SET_DEFAULT_LANGUAGE = "SET_DEFAULT_LANGUAGE";
export const TOGGLE_SURVEY = "TOGGLE_SURVEY";

export const SET_USER_LIST = "SET_USER_LIST";

export const SET_PAGE_REACTION_LIST = "SET_PAGE_REACTION_LIST";
export const UPDATE_PAGE_REACTION_LIST = "UPDATE_PAGE_REACTION_LIST";
export const SET_HAS_REACTIONS = "SET_HAS_REACTIONS";

export function searchInboxList(param) {
    let url;

    if (param?.custom_query && param?.custom_query?.length > 0) url = `${getUrl("smr_service")}/tickets/search`;
    else url = `${getUrl("cxm_inbox")}`;

    let res = axios({
        method: "post",
        url,
        data: param,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "INBOX_LIST_LOADING",
        payload: res,
    };
}

export function agentList() {
    let loggedInUser = store.getState().globalReducer.user.id;
    let res = axios({
        method: "get",
        url: `${getUrl("agent_list")}/users?access-token=${getAccessToken()}`,
        headers: {
            "Content-Type": "application/json",
            cache: false,
        },
    })
        .then((res) => {
            return { data: res.data.data, loggedInUser };
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "SET_AGENT_LIST",
        payload: res,
    };
}

/**
 * @description Variable to handle axios cancel request
 * @type null
 */
let cancel = null;

/**
 * @description Gets facebook(meta) users
 * @param {*} param0
 * @returns
 */
export function getUserList({ platform, page_id, search_query, after, keyCode = 0, loadMore = false }) {
    return async (dispatch) => {
        if (cancel !== null) {
            cancel();
        }

        let data = {
            platform,
            page_id,
            search_query,
        };

        if (after) data.after_cursor = after;

        let config = {
            method: "post",
            url: `${getUrl("user_list")}`,
            headers: {
                Accept: "application/json, text/plain, */*",
                "Accept-Language": "en-GB,en-US;q=0.9,en;q=0.8",
                "Content-Type": "application/json",
                access_token: "8000b9f83ff680212957c4b646a200dd36155907045a8a6b9a9f875ebc2bfa60",
            },
            data,
            cancelToken: new axios.CancelToken(function executor(c) {
                cancel = c;
            }),
        };

        dispatch({
            type: "SET_USER_LIST_PENDING",
            payload: {
                platform,
                keyCode,
                loadMore,
            },
        });

        try {
            const res = await axios.request(config);

            dispatch({
                type: "SET_USER_LIST_FULFILLED",
                payload: {
                    platform,
                    keyCode,
                    data: {
                        user_list: res.data.data.user_lists,
                        after: res.data.data.after,
                        before: res.data.data.before,
                    },
                },
            });
        } catch (error) {
            if (axios.isCancel(error)) {
                return error;
            } else {
                dispatch({
                    type: "SET_USER_LIST_REJECTED",
                });
                return error;
            }
        }
    };
}

/**
 * @description Variable to handle axios cancel request
 * @type null
 */
let cancelCallTwitter = null;

/**
 * @description Fetches x users by making two api calls from es: 0 and es:1
 * @param {*} param
 * @returns
 */
export const getUserListX = ({ platform, page_id, search_query }) => {
    return async (dispatch) => {
        if (cancelCallTwitter !== null) {
            cancelCallTwitter();
        }

        const searchData = (search_from_es) => {
            return {
                platform,
                page_id,
                search_query,
                search_from_es,
            };
        };

        const getConfig = (data) => {
            return {
                method: "post",
                url: `${getUrl("user_list")}`,
                headers: {
                    Accept: "application/json, text/plain, */*",
                    "Accept-Language": "en-GB,en-US;q=0.9,en;q=0.8",
                    "Content-Type": "application/json",
                    access_token: "8000b9f83ff680212957c4b646a200dd36155907045a8a6b9a9f875ebc2bfa60",
                },
                data,
                cancelToken: new axios.CancelToken(function executor(c) {
                    cancelCallTwitter = c;
                }),
            };
        };

        dispatch({
            type: "SET_USER_LIST_PENDING",
            payload: {
                platform: "x",
            },
        });

        try {
            const [res_es_0, res_es_1] = await Promise.all([axios.request(getConfig(searchData(0))), axios.request(getConfig(searchData(1)))]);

            const user_lists = formatXResponseData(res_es_0, res_es_1);

            dispatch({
                type: "SET_USER_LIST_FULFILLED",
                payload: {
                    platform: "x",
                    data: { user_lists },
                },
            });
        } catch (error) {
            if (axios.isCancel(error)) {
                return error;
            } else {
                dispatch({
                    type: "SET_USER_LIST_REJECTED",
                });
                return error;
            }
        }
    };
};

export function teamList(company) {
    let res = axios({
        method: "get",
        url: `${getUrl("smr_service")}/teams/list?company_id=${company}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
    })
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            // toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "SET_SMR_TEAMS_LIST",
        payload: res,
    };
}

export function defaultLanguageList(company) {
    let response = axios({
        method: "get",
        url: `${getUrl("smr_service")}/default-languages?lite_company_id=${company}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
    })
        .then((res) => {
            return res.data?.data;
        })
        .catch((err) => {
            // toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "SET_DEFAULT_LANGUAGE",
        payload: response,
    };
}

export function teamCreate({ data, isClone }) {
    let res = axios({
        method: "post",
        url: `${getUrl("smr_service")}/teams/create?access-token=${getAccessToken()}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data,
    })
        .then((res) => {
            if (isClone) toast.success("Team cloned successfully.");
            else toast.success("Team created successfully.");
            return res.data;
        })
        .catch((err) => {
            if (err.response?.data?.message) toast.error(err.response.data.message);
            else toast.error("Team creation failed.");
            return err.response;
        });
    return {
        type: "CREATE_SMR_TEAM",
        payload: res,
    };
}

export function teamUpdate(data) {
    let res = axios({
        method: "patch",
        url: `${getUrl("smr_service")}/teams/${data.id}?access-token=${getAccessToken()}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data,
    })
        .then((res) => {
            toast.success("Team updated successfully.");
            return res.data.data;
        })
        .catch((err) => {
            if (err.response?.data?.message) toast.error(err.response.data.message);
            else toast.error("Team updation failed.");
            return err;
        });
    return {
        type: "UPDATE_SMR_TEAM",
        payload: res,
    };
}

export function updateTeams(data) {
    let promises = [];

    data.forEach((d) => {
        let res = axios({
            method: "patch",
            url: `${getUrl("smr_service")}/teams/${d.id}?access-token=${getAccessToken()}`,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
                cache: false,
            },
            data: d,
        })
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err.response;
            });

        promises.push(res);
    });

    return Promise.all(promises)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });

    // return {
    //     type: "UPDATE_SMR_TEAMs",
    //     payload: res,
    // };
}

export function teamDelete(data) {
    let res = axios({
        method: "delete",
        url: `${getUrl("smr_service")}/teams/${data.id}?access-token=${getAccessToken()}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    })
        .then((res) => {
            toast.success("Team deleted successfully.");
            return data;
        })
        .catch((err) => {
            if (err.response?.data?.message) toast.error(err.response.data.message);
            else toast.error("Team deletion failed.");
            return err;
        });
    return {
        type: "DELETE_SMR_TEAM",
        payload: res,
    };
}

export function assignAgent(param) {
    let res = axios({
        method: "post",
        url: getUrl("assign_agent"),
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("Agent assigned successfully");
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "ASSIGN_AGENT",
        payload: res,
    };
}

export function updateTicket(param) {
    let res = axios({
        method: "put",
        url: `${getUrl("smr_service")}/tickets/update`,
        data: param,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "UPDATE_TICKET_DETAILS",
        payload: res,
    };
}

export function updateSyncedToSalesforce(param, isTicket = false) {
    let url = isTicket ? `${getUrl("smr_service")}/sync/smr-sf/_bulk` : `${getUrl("smr_service")}/sync/smr-sf/messages/_bulk`;
    let res = axios({
        method: "post",
        url,
        data: param,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "UPDATE_SYNCED_TO_SALESFORCE_DETAILS",
        payload: res,
    };
}

export function updateTicketConv(param) {
    let res = axios({
        method: "put",
        url: `${getUrl("smr_service")}/tickets/reply/update`,
        data: param,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "UPDATE_TICKET_CONV_DETAILS",
        payload: res,
    };
}

export function replyAction(param) {
    let res = axios({
        method: "post",
        url: `${getUrl("smr_service")}/tickets/v2/message/reply?access-token=${getAccessToken()}`,
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "COMMENT_REPLY",
        payload: res,
    };
}

export function setAgentOption(value) {
    return {
        type: "SET_AGENT_OPTION",
        payload: value,
    };
}

export function setOffsetValue(val) {
    return {
        type: "SET_OFFSET_VALUE",
        payload: val,
    };
}

export function updateRoleAction(params) {
    let res = axios({
        method: "post",
        url: getUrl("role_update"),
        headers: {
            "Content-Type": "application/json",
            cache: false,
        },
        data: params,
    })
        .then((res) => {
            toast.success("Updated successfully");
            return res.data;
        })
        .catch(() => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "ROLE_UPDATE",
        payload: res,
    };
}

export function toggleFiltersColumn(val) {
    return {
        type: "TOGGLE_FILTER_COLUMN",
        payload: val,
    };
}
export function setFilters(val) {
    return {
        type: "SET_FILTERS",
        payload: val,
    };
}

export function setSortOption(val) {
    return {
        type: "SET_SORT_OPTION",
        payload: val,
    };
}

export function setSyncSortOption(val) {
    return {
        type: "SET_SYNC_SORT_OPTION",
        payload: val,
    };
}

export function setCustomQuery(payload) {
    return {
        type: "SET_CUSTOM_QUERY",
        payload,
    };
}

export function fetchSMRPageList() {
    let res = axios({
        method: "get",
        url: `${getUrl("social_token_list")}`,
        headers: {
            "Content-Type": "application/json",
            cache: false,
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "FETCH_CXM_PAGES_LIST",
        payload: res,
    };
}

export const setAgentRelatedPages = (smrPagesList) => {
    return {
        type: SET_AGENT_ACCESSABLE_PAGES,
        payload: smrPagesList,
    };
};
export function statusChange(params) {
    let res = axios({
        method: "post",
        url: getUrl("msg_status_change"),
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data: params,
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            throw err;
        });
    return {
        type: "MSG_STATUS_CHANGE",
        payload: res,
    };
}

export function statusUpdate(params) {
    let res = axios({
        method: "post",
        url: `${getUrl("smr_service")}/tickets/status/change`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data: params,
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            if (err.response?.data?.message) toast.error(err.response?.data?.message);
            else toast.error("Status couldn't be updated. Please try again");
            throw err;
        });
    return {
        type: "CURRENT_TICKET_STATUS_CHANGE",
        payload: res,
    };
}

export function saveSocialUserInfo(data) {
    let res = axios({
        method: "post",
        url: `${getUrl("smr_service")}/social-user/info`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data,
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            throw err;
        });

    return {
        type: "SOCIAL_USER_INFO_UPDATE",
        payload: res,
    };
}

export function getSocialUserInfo(params) {
    return (dispatch) => {
        dispatch({ type: "GET_SOCIAL_USER_INFO_PENDING", userId: params.id });

        return axios({
            method: "get",
            url: `${getUrl("smr_service")}/social-user/info?social_uid=${params.id}`,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
                cache: false,
            },
        })
            .then((res) => {
                dispatch({
                    type: "GET_SOCIAL_USER_INFO_FULFILLED",
                    userId: params.id,
                    payload: res.data.data.user_info,
                });
                return res.data;
            })
            .catch((err) => {
                dispatch({ type: "GET_SOCIAL_USER_INFO_REJECTED", userId: params.id, payload: err.response });
                return err.response;
            });
    };
}

export function fetchAutoAssignInfo(companyInfo) {
    let res = axios({
        method: "get",
        url: `${getUrl("cxm_settings")}?lite_company_id=${companyInfo.companyLiteId}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "FETCH_AUTO_ASSIGN",
        payload: res,
    };
}
export function toggleAutoAssign(params, companyInfo) {
    let res = axios({
        method: "put",
        url: `${getUrl("cxm_settings")}/update?lite_company_id=${companyInfo.companyLiteId}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data: params,
    })
        .then((res) => {
            toast.success("Auto assign updated successfully.");
            return { ...res.data, ...params };
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "TOGGLE_AUTO_ASSIGN",
        payload: res,
    };
}

export function setSelectedPages(val) {
    return {
        type: "SET_SELECTED_PAGES",
        payload: val,
    };
}

export const setCurrentPost = (payload, scrollToCurrentPost = false) => ({ type: SET_CURRENT_POST, payload, scrollToCurrentPost });

export const setScrollToPost = (payload) => ({ type: "SET_SCROLL_TO_POST", payload });

export function fetchTicketHistory(params) {
    return (dispatch) => {
        dispatch({ type: "FETCH_TICKET_HISTORY_PENDING", convID: params.postId });

        return axios({
            method: "get",
            url: `${getUrl("smr_service")}/tickets/history?ticket_id=${+params.postId}`,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
                cache: false,
            },
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_TICKET_HISTORY_FULFILLED",
                    convID: params.postId,
                    payload: res.data.data.ticket_history,
                });
                return res.data;
            })
            .catch((err) => {
                dispatch({ type: "FETCH_TICKET_HISTORY_REJECTED", convID: params.postId, payload: err.response });
                return err.response;
            });
    };
}

export function fetchCommentThread1(params) {
    return (dispatch) => {
        dispatch({ type: "FETCH_COMMENTS_THREAD_PENDING", convID: params.postId });

        delete params.data["show_spam_post"];

        return axios({
            method: "post",
            url: `${getUrl("smr_service")}/tickets/${params.postId}/messages/list?access-token=${getAccessToken()}`,
            data: params.data,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_COMMENTS_THREAD_FULFILLED",
                    convID: params.postId,
                    payload: res.data.data,
                });
                return res.data;
            })
            .catch((err) => {
                console.log("error 111", err);
                dispatch({ type: "FETCH_COMMENTS_THREAD_REJECTED", convID: params.postId, payload: err.response?.data });
                return err.response;
            });
    };
}

export const updatePost = (payload) => ({ type: "UPDATE_POST", payload });
export const updateSyncedPost = (payload) => ({ type: "UPDATE_POST_SF_SYNC", payload });

export const updateTicketMessage = (payload) => ({ type: "UPDATE_TICKET_MESSAGE", payload });

export const updateSelectedPosts = (payload) => ({ type: "SELECTED_POSTS", payload });

export const updateFilterUpdated = () => ({ type: "UPDATE_FILTER_UPDATED" });

export const fetchNewParentPost = async (params) => {
    try {
        let res = await axios({
            method: "post",
            url: `${getUrl("smr_service")}/get-parent-post`,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
                cache: false,
            },
            data: params,
        });
        const response = res.data?.data;
        return response;
    } catch (err) {
        toast.error(err.response.data.message);
    }
};

export function fetchParentPost(params) {
    let res = axios({
        method: "post",
        url: `${getUrl("smr_service")}/get-parent-post`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data: params,
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err.response;
        });

    return {
        type: "FETCH_PARENT_POST",
        payload: res,
    };
}

export const smrCleanup = () => ({ type: "SMR_CLEANUP" });

export const setViewTickets = (payload) => ({ type: "SMR_VIEW_TICKETS_SET_FILTERS", payload });

export const getSMRNewPosts = () => {
    let req = axios
        .get(`${getUrl("get_notifications_list")}&limit=50&offset=${0}&channel=smr`, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response.data || {};
        })
        .catch((error) => {
            toast.error(error.response.data.message);
            throw error;
        });

    return {
        type: "SET_SMR_NOTIFICATIONS_LIST",
        payload: req,
    };
};

export const fetchTagsList = (company) => {
    let res = axios({
        method: "get",
        url: `${getUrl("smr_service")}/v2/tags/list?company_id=${company}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
    })
        .then((res) => {
            return res.data.data.rules;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err.response;
        });

    return {
        type: "FETCH_TAGS_LIST",
        payload: res,
    };
};

export const createTags = (data) => {
    let res = axios({
        method: "POST",
        url: `${getUrl("smr_service")}/v2/tags/create`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data,
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err.response;
        });

    return {
        type: "CREATE_TAGS",
        payload: res,
    };
};

export const editTags = ({ params, tag }) => {
    let res = axios({
        method: "PUT",
        url: `${getUrl("smr_service")}/v2/tags/${tag}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data: params,
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err.response;
        });

    return {
        type: "UPDATE_TAGS",
        payload: res,
    };
};

export const deleteTags = (tag) => {
    let res = axios({
        method: "DELETE",
        url: `${getUrl("smr_service")}/v2/tags/${tag}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err.response;
        });

    return {
        type: "DELETE_TAGS",
        payload: res,
    };
};

export function toggleAutoResponse(params, companyInfo, status) {
    let res = axios({
        method: "put",
        url: `${getUrl("cxm_settings")}/update?lite_company_id=${companyInfo.companyLiteId}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data: params,
    })
        .then((res) => {
            toast.success("Changes saved successfully.");
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "TOGGLE_AUTO_RESPONSE",
        payload: res,
    };
}

export function toggleSurvey(params, companyInfo, status) {
    let res = axios({
        method: "put",
        url: `${getUrl("cxm_settings")}/update?lite_company_id=${companyInfo.companyLiteId}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data: params,
    })
        .then((res) => {
            if (params.survey_enabled == 0 || params.survey_enabled == 1) {
                if (!status) {
                    toast.success("Survey enabled successfully.");
                } else {
                    toast.success("Survey disabled successfully.");
                }
            } else {
                toast.success("Setting updated successfully.");
            }
            return { data: res.data, params };
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "TOGGLE_SURVEY",
        payload: res,
    };
}

export function configureAutoResponseInfo(params) {
    let res = axios({
        method: "post",
        url: `${getUrl("smr_service")}/auto-response/configure`,
        data: params,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
    })
        .then((res) => {
            toast.success("Auto Response configured successfully.");
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "FETCH_AUTO_RESPONSE",
        payload: res,
    };
}

export function updatedAutoResponseInfo(params, id) {
    let res = axios({
        method: "patch",
        url: `${getUrl("smr_service")}/auto-response/${id}`,
        data: params,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
    })
        .then((res) => {
            toast.success("Auto Response updated successfully.");
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "UPDATE_AUTO_RESPONSE",
        payload: res,
    };
}

export function fetchAutoResponseInfo(companyInfo) {
    let res = axios({
        method: "get",
        url: `${getUrl("cxm_settings")}?lite_company_id=${companyInfo.companyLiteId}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "FETCH_AUTO_RESPONSE_LIST",
        payload: res,
    };
}

export function responseMode(val) {
    return {
        type: "RESPONSE_MODE",
        payload: val,
    };
}

export function statusList(companyInfo) {
    let res = axios({
        method: "get",
        url: `${getUrl("cxm_inbox_status")}?lite_company_id=${companyInfo.companyLiteId}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
    })
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            // toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "SMR_STATUS_LIST",
        payload: res,
    };
}

export const getSFStatusList = (companyInfo) => {
    let res = axios({
        method: "get",
        url: `${getUrl("sf_status")}?lite_company_id=${companyInfo.companyLiteId}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
    })
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            // toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "SMR_SF_STATUS_LIST",
        payload: res,
    };
};

export function sfUpdatedStatus(param) {
    let res = axios({
        method: "post",
        url: getUrl("sf_updated_status"),
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("Updated successfully");
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "UPDATE_SF_STATUS",
        payload: res,
    };
}

export function createSFStore(param) {
    let res = axios({
        method: "post",
        url: `${getUrl("sf_create_store")}/store?access-token=${getAccessToken()}`,
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            // toast.success("Agent assigned successfully");
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "CREATE_SF_STORE",
        payload: res,
    };
}

export function configSFList() {
    let res = axios({
        method: "get",
        url: `${getUrl("sf_create_store")}/list?access-token=${getAccessToken()}`,
        // data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            // toast.success("Agent assigned successfully");
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "CONFIG_SF_LIST",
        payload: res,
    };
}

export function updateConfigSFList(param, id) {
    let res = axios({
        method: "patch",
        url: `${getUrl("sf_create_store")}/update/${id}`,
        data: param,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    })
        .then((res) => {
            // toast.success("Update successfully.");
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "UPDATE_CONFIG_LIST",
        payload: res,
    };
}

export function sfToken(param) {
    let res = axios({
        method: "post",
        url: getUrl("sf_token"),
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            // toast.success("Update successfully");
            return res.data;
        })
        .catch((err) => {
            // toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "SF_TOKEN",
        payload: res,
    };
}

export function sfStatusSetup() {
    let res = axios({
        method: "post",
        url: getUrl("sf_setup_status"),
        // data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            // toast.success("Update successfully");
            return res.data;
        })
        .catch((err) => {
            // toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "SF_STATUS_SETUP",
        payload: res,
    };
}

export function updateStatusOfActiveUser(params, id) {
    let data = {};
    data["active_status"] = params;

    const req = axios
        .patch(`${getUrl("user_service")}/${id}?access-token=${getAccessToken()}`, data)
        .then((res) => {
            toast.success(`Status updated to ${params} successfully.`);
            // dispatch(gettingStartedProgress());
            return res.data;
        })
        .catch((err) => {
            if (err.response?.data && err.response.data?.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });

    return {
        type: UPDATE_USER_STATUS_INBOX,
        payload: req,
    };
}

export const fetchMessageCount = (param) => {
    let url;
    url = `${getUrl("smr_service")}/tickets/analytics/by_message_count`;

    let res = axios({
        method: "post",
        url,
        data: param,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    })
        .then((res) => {
            return res.data?.data;
        })
        .catch((err) => {
            toast.error(err.response.data?.message);
            return err;
        });
    return {
        type: "FETCH_MSG_COUNT",
        payload: res,
    };
};
export const fetchAllTokens = () => {
    let page_details = {
        facebook: [],
        instagram: [],
        twitter: [],
    };
    let req = axios
        .get(getUrl("social_token_list"))
        .then((response) => {
            response?.data?.data?.tokens?.map((k, v) => {
                if (k.insight_feature === 1) {
                    // k.platform === "facebook" &&

                    switch (k?.platform) {
                        case "facebook":
                            page_details.facebook.push({
                                id: k.page_id,
                                name: k.page_name,
                                username: k.page_username,
                                status: k.status,
                                expiry_date: k.token_expires_at,
                                access_token: k.access_token,
                                handler: k.page_username,
                            });
                            break;
                        case "instagram":
                            page_details.instagram.push({
                                id: k.page_id,
                                name: k.page_name,
                                username: k.page_username,
                                status: k.status,
                                expiry_date: k.token_expires_at,
                                access_token: k.access_token,
                                handler: k.page_username,
                            });
                            break;
                        case "twitter":
                            page_details.twitter.push({
                                id: k.page_id,
                                name: k.page_name,
                                username: k.page_username,
                                status: k.status,
                                expiry_date: k.token_expires_at,
                                access_token: k.access_token,
                                handler: k.page_username,
                            });
                            break;

                        default:
                            break;
                    }
                }
            });

            return page_details;
        })
        .catch((err) => {
            if (err.response && err.response.data && err.response.data.message) {
                toast.error(err.response.data.message);
            } else toast.error("Some error occured");
        });

    return {
        type: "PAGE_TOKEN_LIST",
        payload: req,
    };
};
export const downloadSMRTickets = async (data) => {
    try {
        let url = getUrl("download");
        await axios.post(url, data, {
            cache: false,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });

        toast.success("Your Download request has been received and you will shortly receive an email with the Download link.");
    } catch (error) {
        if (error.response?.data?.message) toast.error(error.response.data.message);
        else toast.error("Some error occurred while processing your request");
    }
};

export const escalateTicket = (params) => {
    let res = axios({
        method: "post",
        url: `${getUrl("smr_service")}/tickets/escalate`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data: params,
    })
        .then((res) => {
            toast.success("Ticket escalated  successfully.");
            return res.data;
        })
        .catch((err) => {
            if (err.response?.data?.message) toast.error(err.response.data.message);
            else toast.error("Team escalation failed.");
            return err.response;
        });
    return {
        type: "ESCALATION_SMR_TICKET",
        payload: res,
    };
};
export const deleteMessageApi = async (data) => {
    try {
        const url = `${getUrl("smr_delete_message")}/delete-message-by-es-id`;
        await axios({
            method: "post",
            url,
            data,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });
        toast.success("Message deleted successfully.");
    } catch (error) {
        if (error.response?.data?.message) toast.error(error.response.data?.message);
        else toast.error("Failed to delete message. Please try again later.");
    }
};

export const hideCommentsApi = async (data) => {
    try {
        const url = `${getUrl("smr_delete_message")}/hide-message-by-es-id`;
        await axios({
            method: "post",
            url,
            data,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });
        toast.success(`Message ${data.hide ? "hidden" : "unhidden"} successfully.`);
    } catch (error) {
        if (error.response?.data?.message) toast.error(error.response.data?.message);
        else toast.error("Failed to hide message. Please try again later.");
    }
};

export const bulkDeleteTickets = async (data) => {
    try {
        const url = `${getUrl("smr_delete_message")}/delete-ticket-by-ticket-es-id`;
        await axios({
            method: "post",
            url,
            data,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });
        toast.success("Tickets deleted successfully.");
    } catch (error) {
        if (error.response?.data?.message) toast.error(error.response.data?.message);
        else toast.error("Failed to delete tickets. Please try again later.");
    }
};

export async function ticketLists(param) {
    try {
        const url = `${getUrl("cxm_inbox")}`;

        const resp = await axios({
            method: "post",
            url,
            data: param,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });

        return {
            data: resp.data?.data?.tickets,
        };
    } catch (err) {
        toast.error(err.response.data.message);
        return {
            error: err.response.data.message,
            data: [],
        };
    }
}

export const createTask = async (params) => {
    try {
        const url = `${getUrl("create_task")}`;
        const response = await axios.post(url, params, {
            headers: {
                "access-token": getAccessToken(),
            },
        });

        return {
            data: response.data?.data?.tasks || [],
        };
    } catch (error) {
        console.log(error);
        return {
            error: true,
            data: [],
            errMsg: error.response?.data?.message,
        };
    }
};

const getTaskDetails = (taskId) => {
    const url = `${getUrl("create_task")}/${taskId}`;
    return axios.get(url, {
        headers: {
            "access-token": getAccessToken(),
        },
    });
};

// create a long poll
export const createPolling =
    ({ currentTicketId, taskId, retryCount = 0 }) =>
    async (dispatch) => {
        try {
            const response = await getTaskDetails(taskId);
            if (response?.data?.data?.task?.status === "done") {
                toast.success("Ticket has been merged successfully");
                dispatch({
                    type: "SMR_QUEUE_TASK_COMPLETE",
                    payload: currentTicketId,
                });
            } else {
                setTimeout(() => {
                    dispatch(createPolling({ currentTicketId, taskId }));
                }, 2000);
            }
            // console.log("responseresponse", response?.data?.data?.task, response?.data?.data?.task?.status == "done");
        } catch (error) {
            if (retryCount >= 5) {
                // toast.error("failed after 5 retires");
                return;
            }

            retryCount += 1;

            // toast.error(`retrying: ${retryCount}`);
            setTimeout(() => {
                dispatch(createPolling({ currentTicketId, taskId, retryCount }));
            }, retryCount * 2000);
        }
    };

export const clearQueuedTicketId = () => {
    return { type: "SMR_QUEUE_TASK_COMPLETE" };
};

/**
 *
 * @param {} data
 */
export const emailTicket = async (data) => {
    try {
        const url = `${getUrl("email_ticket")}`;

        const config = {
            method: "post",
            url,
            headers: {
                Accept: "application/json, text/plain, */*",
            },
            data,
        };

        const response = await axios.request(config);

        toast.success("Ticket emailed successfully.");

        return response.data;
    } catch (error) {
        if (error.response?.data?.message) toast.error(error.response.data?.message);
        else toast.error("Failed to email ticket. Please try again later.");
    }
};

export const fetchTicketSummarizer = async (data) => {
    try {
        const url = `${getUrl("smr_service")}/summarize_chat`;
        const response = await axios({
            method: "post",
            url,
            data,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });
        return {
            data: response.data?.data,
        };
    } catch (error) {
        return {
            data: {},
            error: error.response?.data?.message,
        };
    }
};

const markTicketApi = (data, url) => {
    return axios({
        method: "post",
        url,
        data,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    });
};
export const markTicketAs = async (data, type = "seen") => {
    try {
        const url = `${getUrl("smr_mark_msg_as")}/${type}`;
        await markTicketApi(data, url);
        return {
            success: 1,
        };
    } catch (error) {
        // if (error.response?.data?.message) toast.error(error.response.data?.message);
        // else toast.error("Failed to delete tickets. Please try again later.");
        console.log("error", error);
        return {
            error: 1,
        };
    }
};

export function fetchIndividualTicketData(param) {
    const url = `${getUrl("cxm_inbox")}`;

    let res = axios({
        method: "post",
        url,
        data: param,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    })
        .then((res) => {
            // console.log("fetchIndividualTicketData", res.data?.data);
            return res.data?.data;
        })
        .catch((err) => {
            // toast.error(err.response.data.message);
            console.log("error", err);

            return err;
        });
    return {
        type: "INDIVIDUAL_TICKET_UPDATE",
        payload: res,
    };
}
export const updateTicketCount = (count = 0) => ({
    type: "UPDATE_TICKET_COUNT",
    payload: count,
});

export const fetchSmrKeywordLists = () => {
    let res = axios({
        method: "get",
        url: `${getUrl("smr_keyword")}/list`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
    })
        .then((res) => {
            return res.data?.data?.rules || [];
        })
        .catch((err) => {
            toast.error(err.response?.data?.message);
            return err.response;
        });

    return {
        type: "FETCH_KEYWORD_LISTS",
        payload: res,
    };
};

export const createKeywordRule = async (data, type) => {
    let url;
    let method;
    if (type === "create") {
        url = `${getUrl("smr_keyword")}/create`;
        method = "post";
    } else {
        url = `${getUrl("smr_keyword")}/update`;
        method = "patch";
    }

    try {
        const resp = await axios({
            method,
            url,
            data,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });
        return {
            isSuccess: 1,
        };
    } catch (error) {
        return {
            isSuccess: 0,
            errorMsg: error.response?.data?.message,
        };
    }
};

export const deleteKeywordRule = async (data, keywordName) => {
    try {
        const url = `${getUrl("smr_keyword")}/delete`;

        const resp = await axios({
            method: "delete",
            url,
            data,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });
        toast.success(`${keywordName} deleted successfully`);
    } catch (error) {
        if (error.response?.data?.message) toast.error(error.response.data?.message);
    }
};

export const ValidateKeyword = async (data) => {
    try {
        const url = `${getUrl("validate_rule")}`;

        const resp = await axios({
            method: "post",
            url,
            data,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });

        return {
            isSuccess: resp.data?.data?.is_valid,
            boolean: resp.data?.data?.tokenized_boolean,
        };
    } catch (error) {
        if (error.response?.data?.message) toast.error(error.response.data?.message);
        return {
            isSuccess: 0,
            errorMsg: error.response?.data?.message,
        };
    }
};

/**
 * Adds/Removes reaction to a message.
 *
 * @async
 * @param {Object} params The parameters for the reaction.
 * @param {String} params.message_es_id The ID of the message to react to.
 * @param {String} params.page_id The ID of the page where the message is located.
 * @param {Number} params.unlike Whether to unlike the message.
 * @param {String} params.reaction_type The type of reaction to send.
 * @param {Number | undefined} params.isHidden Whether the message is hidden.
 * @returns {Promise<Object>} Response data.
 * @throws {Error} If the request fails, an error is thrown.
 */
export const reactToMessage = async ({ message_es_id, page_id, unlike, reaction_type, isHidden, isDeleted }) => {
    const reactType = unlike ? "remove" : "add";
    try {
        const url = getUrl("react_to_post");
        const data = {
            message_es_id,
            page_id,
            unlike,
            reaction_type,
        };
        const config = {
            method: "post",
            url,
            data,
            headers: {
                "Content-Type": "application/json",
            },
        };
        const response = await axios.request(config);

        return response.data;
    } catch (err) {
        if (!isHidden && !isDeleted) toast.error(`Failed to ${reactType} reaction. Please try again later.`);
        else if (isHidden) toast.error(`Failed to ${reactType} reaction. Since message is hidden.`);
        else if (isDeleted) toast.error(`Failed to ${reactType} reaction. Since message is deleted.`);
        return err.response.data;
    }
};

export const setHasReactions = ({ reacted, message_es_id }) => ({ type: SET_HAS_REACTIONS, payload: { reacted, message_es_id } });
export const updatePageReactionList = ({ page_id, reacted, message_es_id }) => ({
    type: UPDATE_PAGE_REACTION_LIST,
    payload: { page_id, reacted, message_es_id },
});
export const setPageReactionList = ({ pages, message_es_id }) => ({
    type: SET_PAGE_REACTION_LIST,
    payload: { pages, message_es_id },
});
